import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-check-circle-full_911b34482e67a62b8b0367d1a6245364",
  "use": "ic-check-circle-full_911b34482e67a62b8b0367d1a6245364-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"ic-check-circle-full_911b34482e67a62b8b0367d1a6245364\">\n    <path fill=\"#32BA7C\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id